import { Avatar, Box, Dialog, Divider, Stack, Typography } from "@mui/material";
import moment from 'moment';
import React from "react";
import FileViewer from "react-file-viewer";
import ShowMoreText from "react-show-more-text";
import Slider from "react-slick";
import { useWindowDimensions } from "../../utils";

import { Slider as ImageViewer } from "../../screens/requestView/components/assets";
import { AccordianStyle } from "./styles";

export const ItemDetailsCard = ({ unitDetails = {}, item = {}, checkListGroupDetails = {}, t = () => false, isCustom = false, is_unit = false }) => {
    const size = useWindowDimensions()
    const classes = AccordianStyle()
    const [isViewImages, setIsViewImages] = React.useState({
        imageViewer: false,
        selected_image: []
    })
    const Imgsettings = {
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        // autoplaySpeed: 2000,
        cssEase: "linear",
        arrows: false,
    }
    // const [assetViewDetails, setAssetViewDetails] = React.useState({
    //     item_details: {
    //         "id": "c9b52ec1-2200-470f-a902-611a9da14441",
    //         "name": "Samsung AC 1.5 Ton",
    //         "serial_number": "SMG-2133",
    //         "model_number": "AC-A901",
    //         "manufacturer": "Samsung",
    //         "location": "Bedroom",
    //         "item_asset": [
    //             {
    //                 "url": "https://protomate.objectstore.e2enetworks.net/d00415b7-d318-4c11-ba71-495892e8a3b3/General/1698746603826-images%20%2813%29.jpeg",
    //                 "priority": 1,
    //                 "file_meta": {
    //                     "name": "images (13)",
    //                     "size": "1.39 KB",
    //                     "type": "jpeg"
    //                 },
    //                 "asset_type": 2
    //             },
    //             {
    //                 "url": "https://protomate.objectstore.e2enetworks.net/d00415b7-d318-4c11-ba71-495892e8a3b3/General/1698746604259-blob.jpeg",
    //                 "priority": 2,
    //                 "file_meta": {
    //                     "name": "samsung-3-star-ac",
    //                     "size": "23.52 KB",
    //                     "type": "jpg"
    //                 },
    //                 "asset_type": 2
    //             }
    //         ],
    //         "mapped_asset": null,
    //         "item_condition": "New",
    //         "item_id": "dff29f7b-b28b-4f92-abc5-1ebc67e06b55",
    //         "mapping_assets": null,
    //         "cost_price": 22000,
    //         "device_name": "AC",
    //         "platform": "Smart AC",
    //         "license": "SHHS",
    //         "mac": "3.3232.2",
    //         "imei": "328388383",
    //         "hardware": "Samsung",
    //         "software": "Android",
    //         "firmware": "Knox",
    //         "build": "2992.1.20",
    //         "last_service_date": "2023-11-02T08:23:31.286Z"
    //     }, check_list_group: [
    //         {
    //             "id": "01f84ccb-ce49-4db6-94e6-5e33071faf32",
    //             "name": "31st Item/Asset checklist",
    //             "inspection_type": "Inventory",
    //             "assets": [
    //                 {
    //                     "url": "https://protomate.objectstore.e2enetworks.net/d00415b7-d318-4c11-ba71-495892e8a3b3/General/1698745515671-PDI%20-%20Checklist.pdf",
    //                     "priority": 1,
    //                     "file_meta": {
    //                         "name": "PDI - Checklist",
    //                         "size": "33.39 KB",
    //                         "type": "pdf"
    //                     },
    //                     "asset_type": 2
    //                 }
    //             ],
    //             "instructions": "What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.  Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites sTill in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).   Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of \"de Finibus Bonorum et Malorum\" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.  The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from \"de Finibus Bonorum et Malorum\" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.  Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
    //         }
    //     ]
    // })
    const handleImageView = (data) => {
        // setProduct({ ...product, selectedAsset: data })
        setIsViewImages({
            imageViewer: true, selected_image:
                [{
                    "url": data?.url,
                    "priority": data?.priority,
                    "file_meta": {
                        "name": data?.file_meta?.name,
                        "size": data?.file_meta?.size,
                        "file_type": data?.file_meta?.type
                    },
                    "asset_type": data?.asset_type
                }]
        })
    }
    // close image viwer
    const closeImageViewer = () => {
        setIsViewImages({ ...isViewImages, imageViewer: false, selected_image: [] })
    };
    return (
        <Box p={1} height={isCustom ? size?.height - 90 : size?.height - 80} overflow={"overlay"}>
            {is_unit ?
                <Box className={classes.assetSection}>
                    <center>
                        {(unitDetails?.logo !== null && unitDetails?.logo !== undefined) &&
                            <img src={unitDetails?.logo} alt="unit asset" className={classes.productImage} />

                        }
                        {(unitDetails?.unit_name !== undefined && unitDetails?.unit_name !== null) &&
                            <Box mt={1.5}>
                                <Typography className={classes.itemName}>{unitDetails?.unit_name ?? unitDetails?.name ?? "-"}</Typography>
                            </Box>
                        }
                    </center>
                    <Box mt={2}>
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Property Name")}</Typography>
                            <Typography className={classes.productValue} >{unitDetails?.property_name ?? "-"}</Typography>
                        </Box>
                        <Box mt={1.5} mb={1.5}><Divider /></Box>
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Unit Location")}</Typography>
                            <Typography className={classes.productValue}>{unitDetails?.address ?? unitDetails?.city ?? "-"}</Typography>
                        </Box>
                        <Box mt={1.5} mb={1.5}><Divider /></Box>
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Unit Type")}</Typography>
                            <Typography className={classes.productValue}>{unitDetails?.unit_type ?? "-"}</Typography>
                        </Box>
                        {/* {assetViewDetails?.item_details?.location !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Resident Name")}</Typography>
                                    <Typography className={classes.productValue}>{assetViewDetails?.item_details?.location ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {assetViewDetails?.item_details?.location !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Agreement no")}</Typography>
                                    <Typography className={classes.productValue}>{assetViewDetails?.item_details?.location ?? "-"}</Typography>
                                </Box>
                            </>
                        } */}
                    </Box>
                </Box >
                :
                <Box className={classes.assetSection}>
                    <center>
                        {(item?.assets !== undefined && item?.assets !== null && item?.assets?.length > 0) &&
                            <Slider {...Imgsettings}>
                                {item?.assets?.map((x) => {
                                    return (

                                        <Box mb={1.5} onClick={() => handleImageView(x)}>
                                            <img src={x?.url} alt="product asset" className={classes.productImage} />
                                        </Box>

                                    )
                                })}
                            </Slider>
                        }
                        {item?.item_condition !== null &&
                            <Box className={classes.itemBox}>
                                <Typography className={classes.itemCondition}>{item?.item_condition}</Typography>
                            </Box>
                        }
                        {(item?.item_name !== null && item?.item_name !== undefined) &&
                            <Box mt={1.5}>
                                <Typography className={classes.itemName}>{item?.item_name ?? "-"}</Typography>
                            </Box>
                        }
                    </center>
                    <Box mt={2} maxHeight={"250px"} overflow="scroll">
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Manufacturer")}</Typography>
                            <Typography className={classes.productValue} >{item?.manufacturer_name ?? item?.manufacturer ?? "-"}</Typography>
                        </Box>
                        <Box mt={1.5} mb={1.5}><Divider /></Box>
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Serial Number")}</Typography>
                            <Typography className={classes.productValue}>{item?.serial_number ?? "-"}</Typography>
                        </Box>
                        <Box mt={1.5} mb={1.5}><Divider /></Box>
                        <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                            <Typography className={classes.productTitle}>{t("Model Number")}</Typography>
                            <Typography className={classes.productValue}>{item?.model_number ?? "-"}</Typography>
                        </Box>
                        {item?.location_name !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Location")}</Typography>
                                    <Typography className={classes.productValue}>{item?.location_name ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.last_service_date !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Last Service")}</Typography>
                                    <Typography className={classes.productValue}>{moment(item?.last_service_date)?.format("DD MMM YYYY")}</Typography>
                                </Box>
                            </>
                        }
                        {item?.device_name !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Device Name")}</Typography>
                                    <Typography className={classes.productValue}>{item?.device_name ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.platform !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Platform")}</Typography>
                                    <Typography className={classes.productValue}>{item?.platform ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.license !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("License")}</Typography>
                                    <Typography className={classes.productValue}>{item?.license ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.imei !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("IMEI")}</Typography>
                                    <Typography className={classes.productValue}>{item?.imei ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.mac !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Mac")}</Typography>
                                    <Typography className={classes.productValue}>{item?.mac ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.hardware !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Hardware")}</Typography>
                                    <Typography className={classes.productValue}>{item?.hardware ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.software !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Software")}</Typography>
                                    <Typography className={classes.productValue}>{item?.software ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                        {item?.build !== null &&
                            <>
                                <Box mt={1.5} mb={1.5}><Divider /></Box>
                                <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography className={classes.productTitle}>{t("Build")}</Typography>
                                    <Typography className={classes.productValue}>{item?.build ?? "-"}</Typography>
                                </Box>
                            </>
                        }
                    </Box>
                </Box>
            }
            {
                checkListGroupDetails?.name?.length > 0 &&
                <>
                    <Box mt={2}>
                        <Typography className={classes.instructionsTitle}>{t("Instructions & Documents")}</Typography>
                    </Box>

                    <Box mt={1} className={classes.assetSection}>
                        <>
                            <Box mb={1}>
                                <Typography className={classes.unitNoTitle}>{t("Check List Name")}</Typography>
                                <Typography className={classes.productValue} noWrap>{checkListGroupDetails?.name ?? "-"}</Typography>
                            </Box>
                            <Typography className={classes.unitNoTitle}>{t("Instructions")}</Typography>
                            <Box mt={0.5}>
                                <ShowMoreText
                                    lines={5}
                                    more="Show More"
                                    less="Show Less"
                                    className={classes.productValue}
                                    anchorClass={classes.seeMoreLessTextStyle}
                                    expanded={false}
                                    truncatedEndingComponent={"... "}
                                >
                                    {(checkListGroupDetails?.instructions)?.match(/\n+/g) ?
                                        <Typography className={classes.subtitle2} dangerouslySetInnerHTML={{ __html: (checkListGroupDetails?.instructions).replace(/\n+/g, "<br />") ?? "" }}>
                                        </Typography>
                                        : checkListGroupDetails?.instructions
                                    }
                                    {/* <Typography className={classes.productValue}>{checkListGroupDetails?.instructions?.split("\n")?.map((item, i) => <div key={i}>{item}</div>)}</Typography> */}
                                </ShowMoreText>
                            </Box>
                            {checkListGroupDetails?.assets?.length > 0 &&
                                <Box mt={2}>
                                    <Typography className={classes.unitNoTitle}>{t("Documents")}</Typography>

                                    <Box mt={1}>
                                        {checkListGroupDetails?.assets?.map((x) => {
                                            return (
                                                <Stack direction="row" spacing={1} alignItems="center" mt={1}>


                                                    {x?.file_meta?.type === "pdf" ?
                                                        <Box className={classes.inspectionItemIcon}>
                                                            <FileViewer fileType={x?.file_meta?.type} filePath={x?.url} />
                                                            {/* <DocumentViewer fileType={"pdf"} filePath={`data:application/pdf;base64,${x?.url}`} /> */}
                                                        </Box>
                                                        :
                                                        <Avatar src={x?.url} variant="square" className={classes.inspectionItemIcon} />
                                                    }
                                                    <Box style={{ marginInlineStart: "8px" }}>
                                                        <Typography className={classes.title}>{x?.file_meta?.name ?? "-"}</Typography>
                                                        <Typography className={classes.documentViewTitle} onClick={() => handleImageView(x)}>{t("View")}</Typography>
                                                    </Box>



                                                    {/* <Avatar src={product?.selectedProduct?.assets !== null ? JSON.parse(product?.selectedProduct?.assets)?.[0]?.url : InspectionItem} variant="square" className={classes.inspectionItemIcon} /> */}

                                                </Stack>
                                            )
                                        })}
                                    </Box>
                                </Box>
                            }
                        </>
                    </Box>
                </>
            }
            <Dialog
                open={isViewImages?.imageViewer}
                fullWidth
                maxWidth={"sm"}
                onClose={() => closeImageViewer()}
                className={classes.dialog}
            >
                <Box p={2}>
                    <ImageViewer assets={isViewImages?.selected_image ?? []} />
                </Box>
            </Dialog>
        </Box >
    )
}